import './ImageCard.scss'; // import './css/CustomButton.scss';
import {
    ImageCardProps
} from './models';

import React, { useRef } from 'react';

/*  COMPONENTS  */
import Title from '@shared/library/dist/components/gest/Title/Title';

/*  ICONS   */
import DownloadIcon from '@mui/icons-material/Download';

/*  HELPERS */

import { downloadImageFromUrl } from '@shared/library';
import GestButton from '@shared/library/dist/components/gest/GestInputs/button/GestButton';
import importer from '../../../helpers/importer';



const CustomDetails: React.FC<ImageCardProps>
    = ({
        title = '',

        src,
        alt = '',
        data,
        download,
        actions,

        id,
        selected,


        variant,
        class: classProp,
        style,
        imageStyle,

        // children,

        onClick,
    }) => {


        let className: string[] = ["img-card"];
        switch (variant) {
            case "polaroid": {
                className.push('polaroid');
                break;
            }
            case "classic":
            default: {
                className.push('classic');
                break;
            }
        }


        // if(disabled) className.push("disabled");
        if (selected) className.push("selected");

        if (classProp) className.push(classProp);


        // let childrens = null;
        // if( children && Array.isArray(children) ){
        //     childrens = children.map((component: any, i: number) => component)
        // }else{
        //     childrens = children
        // }

        const ref = useRef<HTMLDivElement>(null);


        return (
            <div
                ref={ref}
                id={id}
                className={className.join(' ')}
                style={style}
                onClick={(e) => {
                    if (onClick) onClick(e, src, alt, data, title, ref);
                }}
            >
                <div className="img">
                    {src ?
                        <img className={undefined} src={src} alt={alt ?? undefined} style={imageStyle} loading='lazy' />
                        :
                        <img className={'no-image'} src={importer.img.require('empty.svg')} alt={undefined} style={imageStyle} loading='lazy' />
                    }
                </div>
                <div className="img-actions">
                    {download &&
                        <GestButton
                            iconBtn
                            icon={<DownloadIcon />}
                            className='img-download'
                            onclick={() => src && downloadImageFromUrl(src)}
                        />
                    }
                    {actions}
                </div>
                {title &&
                    <div className="img-title">
                        <Title size="sm">{title}</Title>
                    </div>
                    // :
                    // <></>
                }
            </div>
        );
    };

export default React.memo(CustomDetails);